import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';

const AboutSnippet = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 px-6 bg-stone-800 text-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-xs font-semibold text-stone-400 tracking-widest mb-3">
              {t('BEHIND LUVing', 'LUVing, 그 뒤에')}
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-5 leading-snug">
              {t(
                'WELCOME',
                '환영합니다. 이곳은 LUVing입니다.'
              )}
            </h2>
            <p className="text-stone-300 text-base leading-relaxed mb-6">
              {t(
                "I am Chaewon Kim, the founder of LUVing and someone living in a globalized international society. LUVing is a bilingual site I built entirely on my own, from concept to design to programming, where international knowledge, issues, and personal perspectives are gathered and shared.",
                "저는 글로벌한 국제 사회를 살아가고 있는 사람이자 LUVing을 제작한 설립자 김채원입니다. LUVing은 제가 기획부터 디자인, 프로그래밍까지 전 과정을 혼자서 구축한 결과물로, 국제적 지식과 문제들, 그리고 개인적 견해를 쌓아가고 공유하는 이중언어 사이트입니다."
              )}
            </p>
            <div className="border-l-2 border-stone-600 pl-4 mb-8">
              <p className="text-stone-300 text-sm leading-relaxed whitespace-pre-line">
                {t(
                  `Change requires something from you.\nMoney, Heart, Time, Love, People\nAnd everything else.\n\nMoney is heart.\nIt can be spent, received, lost, or taken in the name of change.\nIn that movement, it does something: it tells you where our hearts truly are.\n\nTime is love.\nTo spend it on another person is to offer something that cannot be returned.\nIn that irreversibility, love accumulates.\n\nAnd all of this is, finally, about people.\nThe one who spends money with hearts.\nThe one who gives time with love.\nThese are things only you and I, as human beings, can do.\n\nDo not forget: the society we live in, and every change within it, was built on the kindness, or the cost, that countless people once sent forward. To us. Before we even knew how to receive it.`,
                  `변화에는 대가가 따른다.\n돈, 마음, 시간, 사랑, 사람\n그밖의 모든 것들.\n\n돈은 마음이다.\n변화를 위해 쓰기도 받기도 하며 털리고 털어간다.\n그러는 동안 서로의 마음을 가장 확실히 알 수 있는 역할을 한다.\n\n시간은 사랑이다.\n누군가를 위해 돌이킬 수 없는 귀한 자원을 보낸다.\n그 헌신에서 사랑을 받고 보내온 시간이 소복이 쌓인다.\n\n이것들은 사람이다.\n누군가를 변화시키기 위해 돈으로 마음을 알리는 것도\n시간을 다른 이에게 보내 사랑을 실천하는 것도\n결국 사람인 당신과 내가 할 수 있는 일이다.\n\n잊지 말자. 우리가 사는 사회도 변화도 결국 어떤 많은 사람이\n우리에게 보내온 친절 혹은 대가였다는 것을.`
                )}
              </p>
            </div>
            <div className="flex flex-wrap gap-2 mb-8">
              {['Global Affairs', 'International Order', 'Rights and Freedoms', 'Politics', 'Justice and Freedom', 'Law and Society'].map((tag) => (
                <span key={tag} className="text-xs px-3 py-1.5 border border-stone-600 rounded-full text-stone-400">
                  {tag}
                </span>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-sm font-medium text-white border border-white/30 rounded-full px-6 py-2.5 hover:bg-white hover:text-stone-800 cursor-pointer transition-all whitespace-nowrap"
            >
              {t('Read My Story', '내 이야기 읽기')}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-stone-700">
              <img
                src="https://static.readdy.ai/image/87a8138ca64b05ac1815bceaa72b9a44/d696a47159daac83400abac637f2ca9a.jpeg"
                alt="Student studying international law"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/60 to-transparent" />
            </div>
            <div className="absolute -bottom-5 -left-5 bg-white text-stone-800 rounded-2xl p-4 shadow-xl">
              <div className="flex items-center gap-3">
                <div>
                  <p className="text-xs font-bold text-stone-800">{t('Chaewon Kim', '김채원')}</p>
                </div>
              </div>
            </div>
            <div className="absolute -top-4 -right-4 bg-stone-700 rounded-2xl p-4">
              <div className="flex items-center gap-2">
                <span className="text-base">{t('KO', '한국어')}</span>
                <span className="text-xs text-stone-400">+</span>
                <span className="text-base">{t('EN', '영어')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSnippet;